import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function CommunityPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />

      {/* パンくずリスト */}
      <div className="pt-32 pb-6 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="flex items-center space-x-2 text-base">
          <a href="/" className="text-gray-500 hover:text-pink-600 transition-colors cursor-pointer">
            TOP
          </a>
          <span className="text-gray-400">/</span>
          <span className="text-gray-800 font-semibold">コミュニティ</span>
        </div>
      </div>

      {/* ヒーローセクション */}
      <section className="px-6 lg:px-10 pb-20">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            <span className="bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent">
              MAWARI FREAK
            </span>
            <br />
            コミュニティへようこそ
          </h1>
          <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
            一人で悩まない。みんなで学ぶ。初心者からベテランまで、誰もが安心して参加できるあたたかいコミュニティです。
          </p>
        </div>
      </section>

      {/* MAWARI Freakとは */}
      <section className="px-6 lg:px-10 py-20 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-10 lg:p-16">
            <div className="flex items-center justify-center mb-8">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-pink-500 to-rose-500 rounded-full">
                <i className="ri-team-line text-4xl text-white"></i>
              </div>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-8">
              MAWARI Freakとは？
            </h2>
            <div className="space-y-6 text-lg lg:text-xl text-gray-700 leading-relaxed">
              <p>
                <strong className="text-pink-600">MAWARI FREAK</strong>は、MAWARIノードオーナーのための学びと交流の場です。
              </p>
              <p>
                暗号通貨やブロックチェーンが初めての方、シニアの方でも安心して参加できるよう、<strong>「わからないことを気軽に聞ける雰囲気」</strong>を大切にしています。
              </p>
              <p>
                技術的な質問から、日々の疑問、最新ニュースの共有まで、メンバー同士が助け合いながら成長していくコミュニティです。
              </p>
              <div className="bg-gradient-to-r from-pink-100 to-rose-100 rounded-2xl p-8 mt-8">
                <p className="text-xl font-bold text-gray-900 mb-4">
                  💡 こんな方におすすめ
                </p>
                <ul className="space-y-3 text-lg">
                  <li className="flex items-start">
                    <span className="text-pink-600 mr-3">✓</span>
                    <span>暗号通貨やブロックチェーンが初めての方</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-pink-600 mr-3">✓</span>
                    <span>ロッキングやリワードについて詳しく知りたい方</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-pink-600 mr-3">✓</span>
                    <span>同じ目標を持つ仲間と交流したい方</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-pink-600 mr-3">✓</span>
                    <span>最新情報をいち早くキャッチしたい方</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 参加方法 */}
      <section className="px-6 lg:px-10 py-20">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-16">
            参加方法
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* ステップ1 */}
            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-pink-500 to-rose-500 rounded-full mx-auto mb-6">
                <span className="text-4xl font-bold text-white">1</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                お問い合わせ
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                まずは<a href="/contact" className="text-pink-600 font-bold hover:underline cursor-pointer">お問い合わせフォーム</a>から「コミュニティ参加希望」とご連絡ください。
              </p>
            </div>

            {/* ステップ2 */}
            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-pink-500 to-rose-500 rounded-full mx-auto mb-6">
                <span className="text-4xl font-bold text-white">2</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                招待リンク受取
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                運営からコミュニティへの招待リンクをお送りします。
              </p>
            </div>

            {/* ステップ3 */}
            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-pink-500 to-rose-500 rounded-full mx-auto mb-6">
                <span className="text-4xl font-bold text-white">3</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                参加完了！
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                リンクから参加して自己紹介をしたらすぐに交流スタート！
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="/contact"
              className="inline-block px-12 py-5 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xl rounded-full font-bold hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer"
            >
              今すぐ参加する
            </a>
          </div>
        </div>
      </section>

      {/* Zoom定例会 */}
      <section className="px-6 lg:px-10 py-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-10 lg:p-16">
            <div className="flex items-center justify-center mb-8">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-purple-500 to-pink-500 rounded-full">
                <i className="ri-video-chat-line text-4xl text-white"></i>
              </div>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-8">
              Zoom定例会のご案内
            </h2>
            <div className="space-y-6 text-lg lg:text-xl text-gray-700 leading-relaxed">
              <p className="text-lg leading-relaxed">
                月に1〜2回、<strong className="text-pink-600">Zoomでのオンライン定例会</strong>を開催しています。
              </p>
              <p className="text-lg leading-relaxed">
                顔を合わせながら、最新情報の共有や質問タイム、メンバー同士の交流を深める貴重な時間です。
              </p>

              <div className="grid md:grid-cols-2 gap-6 mt-10">
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-calendar-line text-pink-600 mr-3"></i>
                    開催頻度
                  </h3>
                  <p className="text-lg">月1〜2回（不定期）</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-time-line text-pink-600 mr-3"></i>
                    所要時間
                  </h3>
                  <p className="text-lg">約60〜90分</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-user-voice-line text-pink-600 mr-3"></i>
                    参加方法
                  </h3>
                  <p className="text-lg">コミュニティ内で事前告知</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-question-answer-line text-pink-600 mr-3"></i>
                    内容
                  </h3>
                  <p className="text-lg">最新情報・Q&A・交流</p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-pink-100 to-rose-100 rounded-2xl p-8 mt-10">
                <p className="text-xl font-bold text-gray-900 mb-4">
                  📹 録画アーカイブあり
                </p>
                <p className="text-lg">
                  当日参加できなくても大丈夫！定例会の内容は録画され、後日コミュニティ内で共有されます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}